import { CSSProperties } from "react";
import { IonSkeletonText } from "@ionic/react";
import { EventSummary } from "../models/EventSummary";
import { useEventSummaryKeyLocalisedDescriptionQuery } from "../query/eventSummaryKeyLocalisedDescriptionQuery";
import RfidChip from "./RfidChip";

interface EventSummaryDescriptionProps {
    className?: string;
    deviceId: string;
    eventSummary?: EventSummary | null;
    isLoading?: boolean;
    locale: string;
    skeletonStyle?: CSSProperties;
    unknownLabel?: string;
}

function renderLocalisedDescription(localisedDescription: string, deviceId: string, getRfidCodeFromSubstitutionKey: (key: string) => string | null) {
    return localisedDescription
        .split(/(\$\d+)/g)
        .filter(Boolean)
        .map((part, index) => {
            const rfidCode = getRfidCodeFromSubstitutionKey(part);

            if (!rfidCode) {
                return <span key={`${part}-${index}`}>{part}</span>;
            }

            return <RfidChip compact key={`${rfidCode}-${index}`} rfidCode={rfidCode} deviceId={deviceId} />;
        });
}

const EventSummaryDescription: React.FC<EventSummaryDescriptionProps> = ({
    className,
    deviceId,
    eventSummary,
    isLoading = false,
    locale,
    skeletonStyle,
    unknownLabel
}) => {
    const summaryKey = eventSummary?.summaryKey;
    const localisedDescriptionQuery = useEventSummaryKeyLocalisedDescriptionQuery(!!summaryKey ? summaryKey : undefined, locale);
    const localisedDescription = localisedDescriptionQuery.data?.localisedDescription;
    const isSummaryLoading = isLoading || localisedDescriptionQuery.isLoading || eventSummary == null;

    if (localisedDescription) {
        return (
            <div className={className}>
                {renderLocalisedDescription(localisedDescription, deviceId, (key) => eventSummary?.getRfidCodeFromSubstitutionKey(key) ?? null)}
            </div>
        );
    }

    if (isSummaryLoading) {
        return (
            <div className={className}>
                <IonSkeletonText animated style={skeletonStyle} />
            </div>
        );
    }

    return <div className={className}>{unknownLabel}</div>;
};

export default EventSummaryDescription;
